// extracted by mini-css-extract-plugin
export default {"wrapper":"MyTeamMobileEditorHeader__wrapper--wpP_m"};